export const KeyboardCode = {
  ENTER: 13,
};
